export default __webpack_public_path__ + "static/media/20.41b9ccb1.jpg";